import { useEffect, useState } from "react";
import { ButtonLink } from "../components/Button";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Chapter1Desktop,
  Chapter2Desktop,
  Chapter3Desktop,
  Chapter4Desktop,
} from "../assets";
import {
  SubtitleWrapper,
  TextShadeWrapper,
  TitleWrapper,
} from "../components/Wrappers";
import { useWindowSize } from "../Hooks";
import { AMAZON_STORE_LINK } from "../constants";

const BookChapters = () => {
  const window = useWindowSize();
  const [counter, setCounter] = useState(0);
  const [sliceCount, setSliceCount] = useState(2);
  const CHAPTERS = [
    Chapter1Desktop,
    Chapter2Desktop,
    Chapter3Desktop,
    Chapter4Desktop,
  ];

  useEffect(() => {
    setSliceCount(counter + 2);
    // eslint-disable-next-line
  }, [counter]);

  useEffect(() => {
    if (window.width <= 1023.5) {
      setSliceCount(4);
    } else {
      setSliceCount(counter + 2);
    }
    // eslint-disable-next-line
  }, [window]);

  const handleNavigation = (count) => {
    if (counter + count >= 3 || counter + count < 0) return;

    setCounter(counter + count);
  };

  return (
    <div className="chapters">
      <TitleWrapper lineHeight="49px" textAlignSm="left">
        Book <TextShadeWrapper>Chapters</TextShadeWrapper>
      </TitleWrapper>
      <SubtitleWrapper
        maxWidth="535px"
        marginTop="15px"
        marginBottom="50px"
        textAlign="center"
        textAlignSm="left"
      >
        The chapters will explore the challenges and opportunities that
        blockchain technology presents, and the author will consider the future
        of money and finance in a world that is rapidly being transformed by
        blockchain technology.
      </SubtitleWrapper>

      <div className="chapters__container">
        <img
          className={`chapter__btn ${counter <= 0 ? "disable" : ""}`}
          src={ArrowLeftIcon}
          alt="scroll-left"
          onClick={() => handleNavigation(-1)}
        />
        <div className="chapters__card__container">
          {CHAPTERS.slice(counter, sliceCount).map((chapter, i) => (
            <div key={i} className="chapter__content">
              <img src={chapter} alt="chapter1" />
            </div>
          ))}
        </div>
        <img
          className={`chapter__btn ${counter >= 2 ? "disable" : ""}`}
          src={ArrowRightIcon}
          alt="scroll-right"
          onClick={() => handleNavigation(1)}
        />
      </div>
      <ButtonLink
        primaryBtn
        href={AMAZON_STORE_LINK}
        marginTop="50px"
        widthSm="100%"
      >
        Get your Copy
      </ButtonLink>
    </div>
  );
};

export default BookChapters;
